// extracted by mini-css-extract-plugin
module.exports = {"button":"_1XNJB","type1":"_3i_QP","type2":"_2xDRq"};